import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { toast } from 'sonner'

import { AppRoutes } from '@/constants/appRoutes'

export const LoginError = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()

  useEffect(() => {
    const handleLoginError = () => {
      const errorMessage =
        searchParams.get('message') || t('auth.loginError.authenticationFailed')

      // Show the error message using the existing Sonner toast
      toast.error(errorMessage)

      // Redirect back to login page after showing the error
      setTimeout(() => {
        navigate(AppRoutes.login)
      }, 1000) // Small delay to ensure user sees the toast
    }

    handleLoginError()
  }, [searchParams, navigate])

  // This component will redirect immediately, but we show a simple loading state
  // just in case there's any delay
  return (
    <div className="flex items-center justify-center min-h-screen">
      <div className="flex flex-col items-center gap-4">
        <p className="text-lg text-textAccent">
          {t('auth.loginError.redirecting')}
        </p>
      </div>
    </div>
  )
}

export default LoginError
